// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2n-3";
export var dialog = "_2n-0";
export var divClassnameSwatch = "_2n-8";
export var flexSwatch = "_2n-4";
export var header = "_2n-1";
export var styleAttributeSwatch = "_2n-7";
export var swatch = "_2n-2";
export var textHeaderSwatch = "_2n-5";
export var webSwatch = "_2n-6";